// extracted by mini-css-extract-plugin
export default {"background":"Layout_background__zRmHn","wrap":"Layout_wrap__dx45V","navbar":"Layout_navbar__FF5RG"};